import CreateStrategicPlanContainer from "../containers/CreateStrategicPlanContainer";

const CreateStrategicPlanPage = () => {
  return (
    <CreateStrategicPlanContainer />
  );
};

export default CreateStrategicPlanPage;
